import React, { useEffect, useState } from "react";
import API from "../api/api";
import Select from "react-select";
import Swal from "sweetalert2";
import "./AdminLatestManager.css";

export default function AdminLatestManager() {
  const [schemes, setSchemes] = useState([]);
  const [latest, setLatest] = useState([]);

  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSub, setSelectedSub] = useState(null);

  useEffect(() => {
    loadSchemes();
    loadLatest();
  }, []);

  const loadSchemes = async () => {
    const res = await API.get("/schemes/all");
    setSchemes(res.data.data || []);
  };

  const loadLatest = async () => {
    const res = await API.get("/latest/latest-updates");
    setLatest(res.data.data || []);
  };

  const categories =
    schemes.find((s) => s._id === selectedScheme?.value)?.categories || [];

  const subcategories =
    categories.find((c) => c.name === selectedCategory?.value)?.subcategories ||
    [];

  /* ADD TO LATEST */
  const addToLatest = async () => {
    if (!selectedScheme || !selectedCategory || !selectedSub) {
      return Swal.fire({
        icon: "warning",
        title: "Missing Selection",
        text: "Please select Scheme, Category and Subcategory",
        confirmButtonColor: "#fe6e03",
      });
    }

    try {
      await API.patch(
        `/admin/toggle-latest/${selectedScheme.value}/${selectedCategory.value}/${selectedSub.value}`
      );

      loadLatest();

      Swal.fire({
        icon: "success",
        title: "Added to Latest!",
        confirmButtonColor: "#03076b",
      });
    } catch {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        confirmButtonColor: "#fe6e03",
      });
    }
  };

  /* REMOVE LATEST */
  const removeFromLatest = async (item) => {
    const confirm = await Swal.fire({
      title: "Remove Item?",
      text: `${item.categoryName} → ${item.subcategoryName}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#fe6e03",
      cancelButtonColor: "#03076b",
    });

    if (!confirm.isConfirmed) return;

    try {
      await API.patch(
        `/admin/toggle-latest/${item.schemeId}/${item.categoryName}/${item.subcategoryName}`
      );

      loadLatest();

      Swal.fire({
        icon: "success",
        title: "Removed Successfully",
        confirmButtonColor: "#3fad2e",
      });
    } catch {
      Swal.fire({
        icon: "error",
        title: "Error Occurred",
        confirmButtonColor: "#fe6e03",
      });
    }
  };

  return (
    <div className="latest-admin-wrapper">
      <div className="latest-admin-container shadow-lg">

        {/* TITLE */}
        <h2 className="admin-title">Manage Latest Updates</h2>
        <div className="underline"></div>

        {/* PREVIEW SECTION */}
        <h4 className="sub-title">Current Latest Items</h4>

        {latest.length === 0 ? (
          <p className="text-muted">No latest updates added yet.</p>
        ) : (
          <div className="preview-card shadow-sm">
            {latest.map((item, index) => (
              <div key={index} className="preview-row">
                <span>
                  <strong>{item.categoryName}</strong> → {item.subcategoryName}
                </span>
                <button
                  className="btn delete-btn"
                  onClick={() => removeFromLatest(item)}
                >
                  ✖ Remove
                </button>
              </div>
            ))}
          </div>
        )}

        {/* ADD NEW SECTION */}
        <h4 className="sub-title mt-4">Add to Latest</h4>

        <div className="add-card shadow-sm">

          <label className="label-title">Select Service Group</label>
          <Select
            className="react-select mb-3"
            classNamePrefix="react-select"
            options={schemes.map((s) => ({
              value: s._id,
              label: s.mainCategory,
            }))}
            value={selectedScheme}
            onChange={(v) => {
              setSelectedScheme(v);
              setSelectedCategory(null);
              setSelectedSub(null);
            }}
            placeholder="Choose Service Group..."
          />

          <label className="label-title">Select Service Type</label>
          <Select
            className="react-select mb-3"
            classNamePrefix="react-select"
            isDisabled={!selectedScheme}
            options={categories.map((c) => ({
              value: c.name,
              label: c.name,
            }))}
            value={selectedCategory}
            onChange={(v) => {
              setSelectedCategory(v);
              setSelectedSub(null);
            }}
            placeholder="Choose Service Type..."
          />

          <label className="label-title">Select Service Action</label>
          <Select
            className="react-select mb-3"
            classNamePrefix="react-select"
            isDisabled={!selectedCategory}
            options={subcategories.map((s) => ({
              value: s.name,
              label: s.name,
            }))}
            value={selectedSub}
            onChange={setSelectedSub}
            placeholder="Choose Service Action..."
          />

          <button className="btn save-btn w-100" onClick={addToLatest}>
             Add to Latest Updates
          </button>
        </div>
      </div>
    </div>
  );
}
